module.exports = __webpack_public_path__ + "static/media/Basal_6221.edd1534f.jpg";